(function ($) {
    $(document).ready(function() {
        let phoneNumber = $('#phone').text();
        let phoneNumberContactsBlock = $('#phone-block').text();
        let formattedPhoneNumber = formatPhoneNumber(phoneNumber);
        let formattedPhoneNumberContactsBlock = formatPhoneNumber(phoneNumberContactsBlock);
        $('#phone').text(formattedPhoneNumber);
        $('#phone-block').text(formattedPhoneNumberContactsBlock);
    });

    function formatPhoneNumber(phoneNumber) {
        let cleanedNumber = phoneNumber.replace(/\D/g, '');
        return '+7 (' + cleanedNumber.slice(1, 4) + ') ' + cleanedNumber.slice(4, 7) + '-' + cleanedNumber.slice(7, 9) + '-' + cleanedNumber.slice(9);
    }
})(jQuery);
